import React from 'react';
import styles from './SocialButtonsList.scss';
import { IconButton } from '../IconButton/IconButton';
import classNames from 'classnames';
import { whatsappIcon } from '@justgiving/icons';
import Svg from '@justgiving/svg';
import { useShareContext } from '../../context/ShareContext';

interface WhatsAppShareRoundProps {
  className?: string;
  onClick?: () => void;
}

export const WhatsAppShareRound: React.FunctionComponent<WhatsAppShareRoundProps> = ({
  className,
  onClick = () => {},
}) => {
  const { shareItems } = useShareContext();

  const linkItemClick = () => {
    onClick();
  };

  return (
    <IconButton className={`${styles.roundButton} ${className}`}>
      <a
        href={`https://wa.me/?text=${encodeURIComponent(
          shareItems.whatsApp.message,
        )}`}
        data-qa="whatsapp-btn"
        onClick={linkItemClick}
      >
        <div className={classNames(styles.iconWrapper, styles.whatsApp)}>
          <Svg markup={whatsappIcon} className={styles.icon} />
        </div>
        WhatsApp
      </a>
    </IconButton>
  );
};
